import React from 'react'
import { graphql } from 'gatsby'
import TemplateDefault from './case-studies/template-default'
import TemplateCustom from './case-studies/template-custom'
import TemplateDefaultWithQuotes from './case-studies/template-default-with-quotes'

import Layout from '../components/layout'
import Seo from '../components/seo'

import TemplateWithVideo from "./case-studies/template-with-video";

const templateMap = {
    default: TemplateDefault,
    custom: TemplateCustom,
    defaultWithQuotes: TemplateDefaultWithQuotes,
    defaultWithVideo: TemplateWithVideo
}

const CaseStudy = (props) => {
    const { markdownRemark } = props.data
    const { frontmatter } = markdownRemark
    const { template } = frontmatter
    const TemplateComponent = templateMap[template] || TemplateDefault

    return (
        <Layout>
            <Seo
                title={frontmatter.title}
                description={frontmatter.title}
                image={null}
            />
            <TemplateComponent {...markdownRemark} />
        </Layout>
    )
}

export default CaseStudy

export const pageQuery = graphql`
  query($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      fields {
        quoteImage {
          publicURL
        }
        companyLogo {
          publicURL   
        }
      }
      frontmatter {
        slug
        title
        template
        company {
            name
            description
            industry
            industryIcon
            location
        }
        quote {
          name
          role
          text
        }
        quotes {
          text
          author
        }
        challenges {
          text
          title
        }
        solutions
        results {
          kpi
          text
          title
        }
        video {
          title
          url
          author
          role
        }
        cs_types
      }
    }
  }
`
